import { render, staticRenderFns } from "./AllCorridors.vue?vue&type=template&id=4774ebb4&"
import script from "./AllCorridors.vue?vue&type=script&lang=js&"
export * from "./AllCorridors.vue?vue&type=script&lang=js&"
import style0 from "./AllCorridors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports